/*
 * Matuse wetsuit finder — engine + renderer.
 * DRAFT. Runs in two places with the same code:
 *   1. Shopify (sections/wetsuit-finder.liquid): fetches /collections/all/products.json at runtime.
 *   2. Standalone preview (preview/index.html): uses window.MatuseFinderData, a snapshot.
 * No dependencies. Nothing here touches the cart.
 */
(function () {
  'use strict';

  /* ---------- Copy ---------- */
  const COPY = {
    steps: [
      {
        key: 'who',
        eyebrow: 'Who',
        title: 'Men’s or women’s?',
        lede: ''
      },
      {
        key: 'band',
        eyebrow: 'Water',
        title: 'How cold is the water?',
        lede: 'Check the buoy, not the air. Every suit is built to a range and we match you to it.'
      },
      {
        key: 'tier',
        eyebrow: 'Rubber',
        title: 'Which rubber?',
        lede: ''
      },
      {
        key: 'zip',
        eyebrow: 'Entry',
        title: 'Chest zip or back zip?',
        lede: 'A chest zip seals tighter and moves more freely through the shoulders. A back zip is the easier way in and out.'
      }
    ],
    results: {
      eyebrow: 'Your suit',
      title: 'Built for this water.',
      vintageTitle: 'The same build, in vintage.',
      vintageLede: 'Returns and last season’s stock, at a lower price. One-year warranty. Final sale.',
      kitTitle: 'Cover the extremities.',
      kitLede: 'For water this cold, the suit is only part of it.',
      sizingTitle: 'Check your size.',
      sizingLede: '',
      empty: 'Nothing in stock for that exact combination right now.',
      emptyAction: 'Widen the zip and rubber choices',
      showMore: 'Show more',
      showFewer: 'Show fewer'
    },
    size: {
      height: 'Height',
      weight: 'Weight',
      weightOptional: 'Weight (optional for youth)',
      imperial: 'ft / lb',
      metric: 'cm / kg',
      readout: 'Your size',
      between: 'Between sizes, the next closest is',
      sizeUp: 'On the high end of a range? Size up.',
      submit: 'Check my size',
      change: 'Change',
      clear: 'Clear',
      inStock: 'in stock',
      soldOut: 'sold out',
      altInStock: 'in stock, the next closest fit',
      noneInStock: 'Your size is sold out in this suit.',
      viewIn: 'View',
      outside: 'You sit outside our size chart. Write to us and we will size you by hand.',
      notMade: 'Not made in'
    }
  };

  /* ---------- Options ---------- */
  const BANDS = [
    { id: 'b1', f: 'Under 45°F', c: 'under 7°C', note: 'Deep winter. Hood, boots and gloves.' },
    { id: 'b2', f: '45 to 53°F', c: '7 to 12°C', note: 'Winter on the West Coast. Hooded suits start here.' },
    { id: 'b3', f: '53 to 58°F', c: '12 to 14°C', note: 'Early spring, late fall. The 4/3 window.' },
    { id: 'b4', f: '58 to 64°F', c: '14 to 18°C', note: 'Most of the California year. The 3/2 window.' },
    { id: 'b5', f: '64 to 70°F', c: '18 to 21°C', note: 'Late summer. Two millimeters is enough.' },
    { id: 'b6', f: 'Over 70°F', c: 'over 21°C', note: 'Tropics, or August in San Diego. Springsuit water.' }
  ];
  const WHO = [
    { id: 'MEN', f: 'Men’s', note: 'Letter sizes, with short and tall cuts.' },
    { id: 'WOMEN', f: 'Women’s', note: 'Numeric sizes 2 to 12, with short and tall cuts.' },
    { id: 'YOUTH', f: 'Youth', note: 'Sizes 8Y to 16Y.' }
  ];
  const TIERS = [
    { id: 'geoprene', f: 'Geoprene', note: 'Yamamoto limestone, the highest-grade closed-cell foam made in Japan. Two-year warranty.' },
    { id: 'ocena', f: 'Ocena', note: 'Our limestone-based rubber at a lighter price. One-year warranty.' },
    { id: 'both', f: 'Show me both', short: 'Both', note: 'Rank by fit. We’ll say which is which.' }
  ];
  const ZIPS = [
    { id: 'FRONT', f: 'Chest zip', note: 'Tighter seal, freer shoulders. Takes a session to learn.' },
    { id: 'BACK', f: 'Back zip', note: 'Easier in and out. The classic entry.' },
    { id: 'any', f: 'No preference', short: 'Either', note: 'Rank by fit alone.' }
  ];
  const OPTIONS = { band: BANDS, who: WHO, tier: TIERS, zip: ZIPS };

  // Copy overrides from the theme editor (section settings, keys c_q_*, c_opt_*, c_r_*) or window.MatuseFinderCopy.
  function applyCopy(c) {
    if (!c) return;
    // Any field left empty in the editor hides that line. Liquid renders a blank setting as null, so both count.
    const set = function (obj, prop, key) {
      if (!(key in c)) return;
      obj[prop] = (typeof c[key] === 'string') ? c[key].trim() : '';
    };
    COPY.steps.forEach(function (st) { set(st, 'title', 'c_q_' + st.key + '_title'); set(st, 'lede', 'c_q_' + st.key + '_lede'); });
    Object.keys(OPTIONS).forEach(function (k) { OPTIONS[k].forEach(function (o) {
      if (o.name0 == null) o.name0 = o.f;   // shipped name, still used in the rail and the results summary
      set(o, 'f', 'c_opt_' + o.id + '_title'); set(o, 'c', 'c_opt_' + o.id + '_sub'); set(o, 'note', 'c_opt_' + o.id + '_note');
    }); });
    Object.keys(COPY.results).forEach(function (k) { set(COPY.results, k, 'c_r_' + k); });
    Object.keys(COPY.size).forEach(function (k) { set(COPY.size, k, 'c_s_' + k); });
  }

  /* ---------- Imagery ----------
   * Keys are option ids. Defaults point at files already in the store's Files library (the same
   * photos the theme uses on collection and product templates). The Liquid section can override
   * any entry through a <script type="application/json" data-wf-images> block; the preview sets
   * window.MatuseFinderImages. `pos` is the CSS object-position for the crop. */
  const CDN = 'https://cdn.shopify.com/s/files/1/0915/0238/files/';
  const IMAGES = {
    // Water bands, men's side (Alex's photos, 2026-10-15) and women's side. Youth falls back to the men's set.
    b1_MEN: { src: 'wf-mens-snow.webp', pos: '50% 45%' },
    b2_MEN: { src: 'wf-mens-hooded.webp', pos: '50% 30%' },
    b3_MEN: { src: 'wf-mens-barrel.webp', pos: '55% 50%' },
    b4_MEN: { src: 'wf-mens-turn.webp', pos: '50% 50%' },
    b5_MEN: { src: 'wf-montauk-1249.jpg', pos: '50% 20%' },
    b6_MEN: { src: 'wf-mens-longboard.webp', pos: '50% 50%' },
    b1_WOMEN: { src: CDN + 'Diving_Womens_2.png', pos: '50% 50%' },
    b2_WOMEN: { src: 'https://cdn.shopify.com/s/files/1/0915/0238/files/CLIO_FRT.jpg', pos: '50% 15%', fit: 'contain' },
    b3_WOMEN: { src: CDN + 'Cliowater.jpg', pos: '50% 40%' },
    b4_WOMEN: { src: 'wf-montauk-0253.jpg', pos: '50% 25%' },
    b5_WOMEN: { src: 'wf-montauk-1366.jpg', pos: '50% 30%' },
    b6_WOMEN: { src: 'wf-montauk-0136.jpg', pos: '50% 35%' },
    MEN: { src: 'wf-montauk-1652.jpg', pos: '50% 30%' },
    WOMEN: { src: 'wf-montauk-1366.jpg', pos: '50% 30%' },
    YOUTH: { src: 'https://cdn.shopify.com/s/files/1/0915/0238/products/Darc_0081.jpg', pos: '50% 50%', fit: 'contain' },
    geoprene: { src: CDN + 'limestone.jpg', pos: '50% 50%' },
    ocena: { src: CDN + 'shell-header.jpg', pos: '50% 50%' },
    both: { src: CDN + 'ScipioTapingEdit.jpg', pos: '50% 40%' },
    FRONT: { src: CDN + 'Matuse-Josh-8.jpg', pos: '50% 30%' },
    BACK: { src: CDN + 'collection2.png', pos: '50% 25%' },
    any: { src: CDN + 'Banner_2.png', pos: '50% 50%' },
    sizing: { src: CDN + 'frame_0_36_17f.jpg', pos: '50% 50%' }
  };
  function imageFor(key, overrides, who) {
    let o = null;
    if (who) {
      const g = who === 'YOUTH' ? 'MEN' : who;
      o = (overrides && overrides[key + '_' + g]) || IMAGES[key + '_' + g];
    }
    o = o || (overrides && overrides[key]) || IMAGES[key];
    if (!o || !o.src) return null;
    let src = o.src;
    if (/^https?:/.test(src) && /cdn\.shopify\.com/.test(src) && !/\.svg$/.test(src) && src.indexOf('?') < 0) src += '?width=900';
    else if (!/^(https?:)?\//.test(src) && !/^data:/.test(src)) src = (imageFor.assetBase || '') + src;
    return { src: src, pos: o.pos || '50% 50%', fit: o.fit || 'cover' };
  }

  /* ---------- Sizing: provided by assets/size-helper.js (<matuse-size-helper>) ---------- */
  const SH = function () { return window.MatuseSizeHelper || null; };
  function normSize(v) { const m = SH(); return m ? m.normSize(v) : String(v || '').toUpperCase().replace(/\s+/g, ''); }
  function sizeFor(who, inches, lbs) { const m = SH(); return m ? m.sizeFor(who, inches, lbs) : null; }
  // A product's own size options, matched to the chart's naming. Youth variants read "8Y", the chart "8Y".
  function variantFor(p, size) {
    if (!p.sizes || !size) return null;
    const want = normSize(size);
    return p.sizes.filter(function (v) { return v.n === want || v.n === want.replace(/Y$/, ''); })[0] || null;
  }

  /* ---------- Thickness → water fit (3 best · 2 good · 1 workable) ---------- */
  const FIT = {
    b1: { '65': 3, '54': 2 },
    b2: { '54': 3, '43h': 2, '65': 2, '43': 1, '3h': 1 },
    b3: { '43': 3, '43h': 3, '3': 2, '3h': 2, '54': 1, '32': 1 },
    b4: { '32': 3, '3': 2, '2full': 2, '43': 1, 'ls': 1 },
    b5: { '2full': 3, 'ls': 3, '32': 2, 'spring': 1, 'john': 1, '15': 1 },
    b6: { 'spring': 3, '15': 3, 'ls': 2, 'john': 2, '2full': 1 }
  };
  const LABEL = {
    '65': '6/5mm', '54': '5/4mm', '43': '4/3mm', '3': '3mm', '32': '3/2mm',
    '2full': '2mm fullsuit', 'ls': '2mm long-sleeve spring', 'spring': '2mm springsuit',
    'john': 'Sleeveless john', '15': '1.5 to 2mm long-sleeve spring'
  };
  // Open-water and triathlon suits are not surf suits; keep them out of the finder.
  const EXCLUDE = /dojo/i;
  const KIT_TYPES = { Boots: true, Gloves: true, Hoods: true };
  // Only these are suits. Vests, jackets, rashguards, swimwear and bottoms never qualify, whatever their title says.
  const SUIT_TYPES = { Fullsuits: true, Springsuits: true, 'Hooded Fullsuits': true };
  const SUIT_TAGS = { FULLSUITS: true, SPRINGSUITS: true, HOODEDFULLSUITS: true };

  /* ---------- Normalise ---------- */
  function classify(title) {
    const t = String(title).toUpperCase();
    const hooded = /HOODED/.test(t);
    let k = null;
    if (/6\/5/.test(t)) k = '65';
    else if (/5\/4/.test(t)) k = '54';
    else if (/4\/3/.test(t)) k = '43';
    else if (/3\/2/.test(t)) k = '32';
    else if (/\b3\s?MM\b/.test(t)) k = '3';
    else if (/1\.5\s?MM|2\/1\s?MM/.test(t)) k = '15';
    else if (/SHORT SLEEVE FULL|SS FULL/.test(t)) k = '2full';
    else if (/LONG.SLEEVE SPRING|LS SPRING/.test(t)) k = 'ls';
    else if (/2\s?MM FULL|FULL WETSUIT/.test(t)) k = '2full';
    else if (/SPRING|SHORT JOHN/.test(t)) k = 'spring';
    else if (/FULL JOHN/.test(t)) k = 'john';
    return { k: k, hooded: hooded };
  }

  function tagMap(tags) {
    const m = {};
    (tags || []).forEach(function (t) {
      const i = t.indexOf('_');
      if (i > 0) m[t.slice(0, i)] = t.slice(i + 1);
    });
    return m;
  }

  function tempFromBody(html) {
    if (!html) return '';
    const text = String(html).replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ');
    const m = /TEMP RANGE:?\s*([^\n]{3,60}?)(?:\s{2,}|BUILD:|MATERIAL:|$)/i.exec(text);
    return m ? m[1].replace(/\s+/g, ' ').trim().replace(/[\/\s]+$/, '') : '';
  }

  // From /products.json (live) → finder record
  function fromShopify(p) {
    const tg = tagMap(p.tags);
    const sizeIdx = (p.options || []).map(function (o) { return String(o.name || o).toLowerCase(); }).indexOf('size');
    const sizes = sizeIdx < 0 ? null : p.variants.map(function (v) {
      return { n: normSize(v['option' + (sizeIdx + 1)]), label: v['option' + (sizeIdx + 1)], id: v.id, available: !!v.available };
    }).reduce(function (acc, v) {   // one entry per size; available if any colour of it is
      const hit = acc.filter(function (x) { return x.n === v.n; })[0];
      if (!hit) acc.push(v); else if (v.available && !hit.available) { hit.available = true; hit.id = v.id; }
      return acc;
    }, []);
    const prices = p.variants.map(function (v) { return +v.price; });
    const cmps = p.variants.map(function (v) { return v.compare_at_price ? +v.compare_at_price : 0; });
    return {
      handle: p.handle, title: p.title, type: p.product_type || '',
      price: Math.min.apply(null, prices), compare: Math.max.apply(null, cmps) || null,
      available: p.variants.filter(function (v) { return v.available; }).length,
      variants: p.variants.length,
      gender: tg.GENDER || '', material: tg.MATERIAL || '', zip: tg.ZIPPER || '',
      model: tg.MODEL || '', line: tg.LINE || '', typeTag: tg.TYPE || '',
      finder: (p.tags || []).filter(function (t) { return t.indexOf('FINDER_') === 0; }).map(function (t) { return t.slice(7).toUpperCase(); }),
      image: p.images && p.images[0] ? p.images[0].src.split('?')[0] : '',
      tempText: tempFromBody(p.body_html), tempBands: [], sizes: sizes
    };
  }

  function enrich(p) {
    const c = classify(p.title);
    p.k = c.k; p.hooded = c.hooded;
    p.tier = p.material === 'GEOPRENE' ? 'geoprene' : (p.material ? 'ocena' : '');
    p.materialLabel = { GEOPRENE: 'Geoprene', OCENA: 'Ocena', GEOFLEX: 'Geoflex' }[p.material] || '';
    p.isKit = !!KIT_TYPES[p.type];
    const suitType = !!SUIT_TYPES[p.type] || (!p.type && !!SUIT_TAGS[p.typeTag]);
    p.finder = p.finder || [];
    p.pinned = p.finder.indexOf('PIN') >= 0;
    p.isSuit = suitType && p.type !== 'Swimwear' && !p.isKit && !!p.k && !EXCLUDE.test(p.handle) && !EXCLUDE.test(p.title) && p.finder.indexOf('HIDE') < 0;
    p.vintage = p.line === 'VINTAGE';
    p.url = '/products/' + p.handle;
    p.group = [p.model, p.k, p.hooded ? 'h' : '', p.zip, p.line, p.material].join('|');
    return p;
  }

  /* ---------- Scoring ---------- */
  function fitFor(p, band) {
    const table = FIT[band] || {};
    const hk = p.k + (p.hooded ? 'h' : '');
    if (table[hk] != null) return table[hk];
    if (table[p.k] != null) return table[p.k];
    return 0;
  }

  function matchesWho(p, who) {
    return p.gender === who || p.gender === 'UNISEX';
  }

  function score(p, a) {
    const fit = fitFor(p, a.band);
    if (!fit) return null;
    let s = fit * 10;
    if (p.pinned) s += 100;   // FINDER_PIN: Alex's pick leads whenever it fits the band and is in stock
    if (a.zip !== 'any' && p.zip) s += (p.zip === a.zip) ? 3 : -2;
    if (a.tier === 'both' && p.tier === 'geoprene') s += 0.5; // our standard breaks ties
    s += Math.min(p.available, 6) * 0.1;
    if (a.sizeRec && p.sizes) {
      const v1 = variantFor(p, a.sizeRec.primary), v2 = variantFor(p, a.sizeRec.alt);
      s += (v1 && v1.available) ? 4 : ((a.sizeRec.close && v2 && v2.available) ? 2 : -3);
    }
    return s;
  }

  function dedupe(list) {
    const seen = {}; const out = [];
    list.forEach(function (p) {
      if (seen[p.group]) { seen[p.group].colors += 1; return; }
      p.colors = 1; seen[p.group] = p; out.push(p);
    });
    return out;
  }

  // Warm-to-cold order of builds, used only to find the nearest suit when nothing fits the band.
  const WARMTH = ['65', '54', '43h', '43', '3h', '3', '32', '2full', 'ls', 'spring', 'john', '15'];
  const BAND_TARGET = { b1: 0, b2: 1, b3: 3, b4: 6, b5: 8, b6: 9 };
  function closest(products, a) {
    const target = BAND_TARGET[a.band] || 0;
    const pool = products.filter(function (p) {
      return p.isSuit && !p.vintage && matchesWho(p, a.who) && p.available > 0 && (a.tier === 'both' || p.tier === a.tier);
    }).map(function (p) {
      const i = WARMTH.indexOf(p.k + (p.hooded ? 'h' : '')); const j = WARMTH.indexOf(p.k);
      p._dist = Math.abs((i >= 0 ? i : j) - target); return p;
    }).sort(function (x, y) { return x._dist - y._dist || y.available - x.available; });
    return dedupe(pool).slice(0, 3);
  }

  // Break ties in the top slots in the shopper's favour. When they said "no preference" on zip, or "both"
  // rubbers, suits that tie on fit should not all share one zip or one rubber just because of catalog order.
  // Only near-ties move (within one point of the best remaining score); a better-fitting suit is never displaced.
  function diversify(list, a, slots) {
    if (list.length <= slots) return list;
    const rest = list.slice(); const lead = []; const seen = { zip: {}, tier: {}, model: {} };
    while (lead.length < slots && rest.length) {
      const best = rest[0]._r.s;
      let pickIdx = 0, pickAdj = -Infinity;
      for (let i = 0; i < rest.length; i++) {
        const p = rest[i], base = p._r.s;
        if (best - base > 1.0) break;
        let adj = base;
        if (a.zip === 'any' && seen.zip[p.zip]) adj -= 0.6;
        if (a.tier === 'both' && seen.tier[p.tier]) adj -= 0.4;
        if (seen.model[p.model]) adj -= 0.3;
        if (adj > pickAdj) { pickAdj = adj; pickIdx = i; }
      }
      const p = rest.splice(pickIdx, 1)[0];
      seen.zip[p.zip] = true; seen.tier[p.tier] = true; seen.model[p.model] = true;
      lead.push(p);
    }
    return lead.concat(rest);
  }

  function recommend(products, a) {
    const pool = products.filter(function (p) {
      return p.isSuit && matchesWho(p, a.who) && p.available > 0 && (a.tier === 'both' || p.tier === a.tier);
    });
    const scored = pool.map(function (p) { const s = score(p, a); return s == null ? null : { p: p, s: s, fit: fitFor(p, a.band) }; })
      .filter(Boolean).sort(function (x, y) { return y.s - x.s; });
    let current = dedupe(scored.filter(function (r) { return !r.p.vintage; }).map(function (r) { r.p._r = r; return r.p; }));
    current = diversify(current, a, 3);
    const vintage = dedupe(scored.filter(function (r) { return r.p.vintage && r.fit >= 2; }).map(function (r) { r.p._r = r; return r.p; }));
    const kit = [];
    if (['b1', 'b2', 'b3', 'b4'].indexOf(a.band) >= 0) {
      const boots = products.filter(function (p) { return p.type === 'Boots' && !p.vintage && p.available > 0; })[0];
      const gloves = products.filter(function (p) { return p.type === 'Gloves' && !p.vintage && p.available > 0; })
        .sort(function (x, y) { return (a.band === 'b1' || a.band === 'b2') ? y.price - x.price : x.price - y.price; })[0];
      if (boots) kit.push(boots);
      if (gloves && a.band !== 'b4') kit.push(gloves);
    }
    const fallback = current.length ? [] : closest(products, a);
    return { current: current, vintage: vintage, kit: kit, fallback: fallback };
  }

  /* ---------- Render ---------- */
  function h(tag, attrs, children) {
    const el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') el.className = attrs[k];
      else if (k === 'html') el.innerHTML = attrs[k];
      else if (k.slice(0, 2) === 'on') el.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] != null) el.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c == null) return; el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }
  function money(n) { return '$' + Math.round(n).toLocaleString('en-US'); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function cleanTitle(t) { return String(t).replace(/\s*\[VINTAGE\]\s*$/i, ''); }
  function labelFor(id, list) { const o = list.filter(function (x) { return x.id === id; })[0]; return o ? (o.f || o.name0 || '') : ''; }
  function shortFor(id, list) { const o = list.filter(function (x) { return x.id === id; })[0]; return o ? (o.short || o.f || o.name0 || '') : ''; }
  function lowerBand(f) { return f.replace(/^Under/, 'under').replace(/^Over/, 'over'); }

  function Finder(root, opts) {
    this.root = root; this.opts = opts || {};
    this.products = []; this.answers = { band: null, who: null, tier: null, zip: null };
    this.step = 0; // 0..4 questions, 5 results
    this.units = 'imperial';
    this.expanded = false;
    this.images = window.MatuseFinderImages || null;
    applyCopy(window.MatuseFinderCopy || null);
    const copyJson = root.querySelector('script[data-wf-copy]');
    if (copyJson) { try { applyCopy(JSON.parse(copyJson.textContent)); } catch (e) { /* ignore */ } }
    imageFor.assetBase = (opts && opts.assetBase) || root.dataset.assetBase || window.MatuseFinderAssetBase || '';
    const json = root.querySelector('script[data-wf-images]');
    if (json) { try { this.images = Object.assign({}, this.images || {}, JSON.parse(json.textContent)); } catch (e) { /* ignore */ } }
    this.readHash();
  }

  Finder.prototype.readHash = function () {
    const m = /wf=([^&]+)/.exec(location.hash);
    if (!m) return;
    const parts = m[1].split('.');
    if (parts.length >= 4) {
      this.answers = { who: parts[0], band: parts[1], tier: parts[2], zip: parts[3], size: null };
      if (parts[4] && parts[4] !== 'x') this.answers.size = { h: parseFloat(parts[4]) || 0, w: parseFloat(parts[5]) || 0 };
      this.step = COPY.steps.length;
    }
  };
  Finder.prototype.writeHash = function () {
    const a = this.answers;
    const sz = (a.size && a.size.h) ? [Math.round(a.size.h * 10) / 10, Math.round(a.size.w || 0)] : [];
    if (this.step === COPY.steps.length && a.band) history.replaceState(null, '', '#wf=' + [a.who, a.band, a.tier, a.zip].concat(sz).join('.'));
    else if (location.hash.indexOf('wf=') >= 0) history.replaceState(null, '', location.pathname + location.search);
  };

  Finder.prototype.load = function () {
    const self = this;
    if (window.MatuseFinderData) {
      this.products = window.MatuseFinderData.map(function (p) { return enrich(Object.assign({}, p)); });
      return Promise.resolve();
    }
    const base = (this.opts.endpoint || '/collections/all/products.json') + '?limit=250&page=';
    const all = [];
    function page(n) {
      return fetch(base + n, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          d.products.forEach(function (p) { all.push(p); });
          return (d.products.length === 250 && n < 4) ? page(n + 1) : null;
        });
    }
    return page(1).then(function () {
      self.products = all.map(fromShopify).map(enrich);
    });
  };

  Finder.prototype.choose = function (key, id) {
    this.answers[key] = id;
    const idx = COPY.steps.findIndex(function (s) { return s.key === key; });
    this.step = Math.min(idx + 1, COPY.steps.length);
    this.expanded = false;
    this.render();
  };
  Finder.prototype.go = function (step) { this.step = step; this.render(); };
  Finder.prototype.reset = function () { this.answers = { band: null, who: null, tier: null, zip: null, size: null }; this.step = 0; this.render(); };

  Finder.prototype.render = function () {
    const self = this;
    this.writeHash();
    const root = this.root; root.innerHTML = '';
    root.setAttribute('data-step', this.step);

    // Progress rail
    const rail = h('ol', { class: 'wf__rail', 'aria-label': 'Steps' }, COPY.steps.map(function (s, i) {
      const done = self.answers[s.key] != null;
      const li = h('li', { class: 'wf__rail-item' + (i === self.step ? ' is-current' : '') + (done ? ' is-done' : '') }, [
        h('button', { type: 'button', class: 'wf__rail-btn', disabled: (!done && i > self.step) ? 'disabled' : null, onclick: function () { self.go(i); } }, [
          h('span', { class: 'wf__rail-num' }, [pad(i + 1)]),
          h('span', { class: 'wf__rail-label' }, [done ? shortFor(self.answers[s.key], OPTIONS[s.key]) : s.eyebrow])
        ])
      ]);
      return li;
    }));
    root.appendChild(rail);

    if (this.step < COPY.steps.length) this.renderStep(COPY.steps[this.step]);
    else this.renderResults();

    // Move focus to the new heading for keyboard and screen reader users
    const heading = root.querySelector('.wf__q-title, .wf__results-title, .wf__grid, .wf__cards');
    if (heading && root.dataset.touched === '1') { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: false }); root.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
    root.dataset.touched = '1';
  };

  Finder.prototype.renderStep = function (s) {
    const self = this; const list = OPTIONS[s.key]; const i = this.step;
    const sec = h('section', { class: 'wf__q', 'aria-labelledby': 'wf-q-' + s.key }, [
      h('p', { class: 'wf__eyebrow' }, [pad(i + 1) + ' / ' + pad(COPY.steps.length) + ' — ' + s.eyebrow]),
      s.title ? h('h2', { class: 'wf__q-title', id: 'wf-q-' + s.key }, [s.title]) : null,
      s.lede ? h('p', { class: 'wf__lede' }, [s.lede]) : null,
      h('div', { class: 'wf__grid wf__grid--' + s.key, role: 'group', 'aria-label': s.title || s.eyebrow }, list.map(function (o) {
        const selected = self.answers[s.key] === o.id;
        const img = imageFor(o.id, self.images, s.key === 'band' ? self.answers.who : null);
        return h('button', { type: 'button', class: 'wf__opt' + (selected ? ' is-selected' : '') + (img ? ' wf__opt--photo' : ''), 'aria-pressed': selected ? 'true' : 'false', onclick: function () { self.choose(s.key, o.id); } }, [
          img ? h('span', { class: 'wf__opt-media' + (img.fit === 'contain' ? ' wf__opt-media--contain' : ''), 'aria-hidden': 'true' }, [h('img', { src: img.src, alt: '', loading: 'lazy', style: 'object-position:' + img.pos + ';object-fit:' + img.fit })]) : null,
          h('span', { class: 'wf__opt-body' }, [
            o.f ? h('span', { class: 'wf__opt-title' }, [o.f]) : null,
            o.c ? h('span', { class: 'wf__opt-sub' }, [o.c]) : null,
            o.note ? h('span', { class: 'wf__opt-note' }, [o.note]) : null
          ])
        ]);
      })),
      i > 0 ? h('div', { class: 'wf__nav' }, [h('button', { type: 'button', class: 'wf__link', onclick: function () { self.go(i - 1); } }, ['← Back'])]) : null
    ]);
    this.root.appendChild(sec);
  };

  Finder.prototype.sizeRec = function () {
    const sz = this.answers.size;
    if (!sz || sz === 'skip' || !sz.h) return null;
    return sizeFor(this.answers.who, sz.h, sz.w);
  };

  // The size helper is the shared <matuse-size-helper> component (assets/size-helper.js). The finder feeds it
  // the cut, the saved entry and the copy, and listens for the result. It remembers the entry in localStorage,
  // so a shopper who sized here arrives on a product page already sized.
  Finder.prototype.renderSizePanel = function () {
    const self = this; const a = this.answers; const C = COPY.size;
    if (!window.customElements || !customElements.get('matuse-size-helper')) return null;
    const el = document.createElement('matuse-size-helper');
    el.setAttribute('gender', a.who || 'MEN');
    el.setAttribute('units', this.units);
    if (a.size && a.size.h) { el.setAttribute('height', a.size.h); el.setAttribute('weight', a.size.w || 0); }
    if (this.opts.sizeGuideUrl !== '') el.setAttribute('size-guide', this.opts.sizeGuideUrl || '/pages/size-fit-guide');
    if (this.opts.contactUrl !== '') el.setAttribute('contact', this.opts.contactUrl || '/pages/contact');
    const copy = Object.assign({}, C, { title: COPY.results.sizingTitle, lede: COPY.results.sizingLede });
    const json = document.createElement('script'); json.type = 'application/json'; json.textContent = JSON.stringify({ copy: copy }); el.appendChild(json);
    el.addEventListener('size-helper:result', function (e) {
      const r = e.detail; const cur = a.size && a.size.h ? a.size : null;
      self.units = el.units || self.units;
      if (cur && Math.abs(cur.h - r.inches) < 0.05 && Math.abs((cur.w || 0) - (r.lbs || 0)) < 0.5) return;
      a.size = { h: r.inches, w: r.lbs || 0 }; self.expanded = false; self.render();
      const cards = self.root.querySelector('.wf__cards'); if (cards && cur) cards.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
    el.addEventListener('size-helper:clear', function () { a.size = null; self.render(); });
    return h('div', { class: 'wf__sizehelper' }, [el]);
  };

  Finder.prototype.renderResults = function () {
    const self = this; const a = this.answers;
    a.sizeRec = this.sizeRec();
    const rec = recommend(this.products, a);
    const band = BANDS.filter(function (b) { return b.id === a.band; })[0] || BANDS[0];

    const summary = h('p', { class: 'wf__summary' }, [
      'For ', h('button', { type: 'button', class: 'wf__chip', onclick: function () { self.go(1); } }, [(band.f || band.name0) + ' water']),
      ', cut for ', h('button', { type: 'button', class: 'wf__chip', onclick: function () { self.go(0); } }, [labelFor(a.who, WHO).toLowerCase()]),
      ', in ', h('button', { type: 'button', class: 'wf__chip', onclick: function () { self.go(2); } }, [a.tier === 'both' ? 'either rubber' : labelFor(a.tier, TIERS)]),
      ', ', h('button', { type: 'button', class: 'wf__chip', onclick: function () { self.go(3); } }, [a.zip === 'any' ? 'any entry' : labelFor(a.zip, ZIPS).toLowerCase()]),
      a.sizeRec ? ', size ' : '', a.sizeRec ? h('button', { type: 'button', class: 'wf__chip', onclick: function () { const el = self.root.querySelector('matuse-size-helper'); if (el) { el.open = true; el.render(); el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } } }, [a.sizeRec.primary]) : '', '.'
    ]);

    const head = h('header', { class: 'wf__results-head' }, [
      COPY.results.eyebrow ? h('p', { class: 'wf__eyebrow' }, [COPY.results.eyebrow]) : null,
      COPY.results.title ? h('h2', { class: 'wf__results-title' }, [COPY.results.title]) : null,
      summary,
      h('p', { class: 'wf__adjust' }, [
        'Run cold? ',
        a.band !== 'b1' ? h('button', { type: 'button', class: 'wf__link', onclick: function () { self.answers.band = 'b' + (parseInt(a.band.slice(1), 10) - 1); self.render(); } }, ['Go one band colder']) : h('span', {}, ['You’re already at the coldest band.']),
        ' · ',
        h('button', { type: 'button', class: 'wf__link', onclick: function () { self.reset(); } }, ['Start over'])
      ])
    ]);
    this.root.appendChild(head);
    const helper = this.renderSizePanel(); if (helper) this.root.appendChild(helper);

    // Primary
    const shown = this.expanded ? rec.current : rec.current.slice(0, 3);
    if (!rec.current.length) {
      this.root.appendChild(h('div', { class: 'wf__empty' }, [
        (rec.fallback.length || COPY.results.empty) ? h('p', {}, [rec.fallback.length ? ('Nothing we make is built for ' + lowerBand(band.f || band.name0 || '') + ' water in a ' + labelFor(a.who, WHO).toLowerCase() + ' cut' + (a.tier !== 'both' ? ' in ' + labelFor(a.tier, TIERS) : '') + '. These are the closest.') : COPY.results.empty]) : null,
        ((a.zip !== 'any' || a.tier !== 'both') && COPY.results.emptyAction) ? h('button', { type: 'button', class: 'wf__btn wf__btn--outline', onclick: function () { self.answers.zip = 'any'; self.answers.tier = 'both'; self.render(); } }, [COPY.results.emptyAction]) : null
      ]));
      if (rec.fallback.length) {
        this.root.appendChild(h('div', { class: 'wf__cards', style: 'margin-top: var(--wf-gap)' }, rec.fallback.map(function (p) { return self.card(p, a, false, false, 'Closest we make'); })));
      }
    } else {
      this.root.appendChild(h('div', { class: 'wf__cards' }, shown.map(function (p, i) { return self.card(p, a, i === 0 && !self.expanded); })));
      const moreLabel = self.expanded ? COPY.results.showFewer : COPY.results.showMore;
      if (rec.current.length > 3 && moreLabel) {
        this.root.appendChild(h('div', { class: 'wf__more' }, [
          h('button', { type: 'button', class: 'wf__btn wf__btn--outline', onclick: function () { self.expanded = !self.expanded; self.render(); } }, [moreLabel])
        ]));
      }
    }

    // Vintage
    if (this.opts.showVintage !== false && rec.vintage.length) {
      this.root.appendChild(h('section', { class: 'wf__sub' }, [
        COPY.results.vintageTitle ? h('h3', { class: 'wf__sub-title' }, [COPY.results.vintageTitle]) : null,
        COPY.results.vintageLede ? h('p', { class: 'wf__lede' }, [COPY.results.vintageLede]) : null,
        h('div', { class: 'wf__cards wf__cards--compact' }, rec.vintage.slice(0, 3).map(function (p) { return self.card(p, a, false); }))
      ]));
    }

    // Kit
    if (this.opts.showKit !== false && rec.kit.length) {
      this.root.appendChild(h('section', { class: 'wf__sub' }, [
        COPY.results.kitTitle ? h('h3', { class: 'wf__sub-title' }, [COPY.results.kitTitle]) : null,
        COPY.results.kitLede ? h('p', { class: 'wf__lede' }, [COPY.results.kitLede]) : null,
        h('div', { class: 'wf__cards wf__cards--compact' }, rec.kit.map(function (p) { return self.card(p, a, false, true); }))
      ]));
    }

    // (sizing lives in the helper above the cards)
  };

  Finder.prototype.card = function (p, a, lead, isKit, badgeOverride) {
    const fit = isKit ? 0 : fitFor(p, a.band);
    const why = [];
    if (!isKit) {
      why.push((LABEL[p.k] || '') + (p.hooded && !/hooded/i.test(LABEL[p.k] || '') ? ', hooded' : ''));
      if (p.tempText) why.push('Built for ' + p.tempText.replace(/F\b/g, '°F').replace(/C\b/g, '°C'));
      if (p.zip === 'FRONT') why.push('Chest zip'); else if (p.zip === 'BACK') why.push('Back zip');
      if (p.materialLabel) why.push(p.materialLabel + ', ' + ((p.tier === 'geoprene' && !p.vintage) ? 'two-year' : 'one-year') + ' warranty');
    }
    const badge = badgeOverride || (isKit ? null : (fit === 3 ? 'Best for this water' : fit === 2 ? 'Works here' : 'Workable'));
    // Size: if the shopper gave height and weight, say whether their size is in stock and link straight to it.
    let sizeLine = null, pick = null, link = p.url;
    const sr = !isKit && a.sizeRec;
    if (sr && p.sizes) {
      const v1 = variantFor(p, sr.primary), v2 = variantFor(p, sr.alt);
      if (v1 && v1.available) { pick = v1; sizeLine = h('p', { class: 'wf__size wf__size--ok' }, [h('strong', {}, [v1.label]), ' ' + COPY.size.inStock]); }
      else if (sr.close && v2 && v2.available) { pick = v2; sizeLine = h('p', { class: 'wf__size' }, [sr.primary + ' ' + COPY.size.soldOut + '. ', h('strong', {}, [v2.label]), ' ' + COPY.size.altInStock + '.']); }
      else if (v1) { sizeLine = h('p', { class: 'wf__size wf__size--out' }, [COPY.size.noneInStock]); }
      else { sizeLine = h('p', { class: 'wf__size wf__size--out' }, [COPY.size.notMade + ' ' + sr.primary + '.']); }
      if (pick) link = p.url + '?variant=' + pick.id;
    }
    return h('article', { class: 'wf__card' + (lead ? ' wf__card--lead' : '') + (p.vintage ? ' wf__card--vintage' : '') }, [
      h('a', { class: 'wf__card-media', href: p.url, 'aria-hidden': 'true', tabindex: '-1' }, [
        p.image ? h('img', { src: p.image + (p.image.indexOf('cdn.shopify.com') > 0 ? '?width=900' : ''), alt: '', loading: 'lazy' }) : h('span', { class: 'wf__card-noimg' })
      ]),
      h('div', { class: 'wf__card-body' }, [
        badge ? h('p', { class: 'wf__badge' + (fit === 3 ? ' wf__badge--best' : '') }, [badge]) : null,
        h('h4', { class: 'wf__card-title' }, [h('a', { href: p.url }, [cleanTitle(p.title)])]),
        h('p', { class: 'wf__price' }, [
          h('span', {}, [money(p.price)]),
          p.compare && p.compare > p.price ? h('s', { class: 'wf__compare' }, [money(p.compare)]) : null,
          p.vintage ? h('span', { class: 'wf__tag' }, ['Vintage']) : null
        ]),
        why.length ? h('p', { class: 'wf__why' }, [why.join(' · ')]) : null,
        sizeLine,
        h('a', { class: 'wf__btn wf__btn--sm', href: link }, [isKit ? 'View' : (pick ? COPY.size.viewIn : 'View the suit')])
      ])
    ]);
  };

  /* ---------- Mount ---------- */
  function mount(el, opts) {
    const f = new Finder(el, opts);
    el.innerHTML = '<p class="wf__loading">Loading the line…</p>';
    f.load().then(function () { f.render(); }).catch(function (e) {
      el.innerHTML = '<p class="wf__loading">The finder couldn’t load the catalog. <a href="/collections/all">Browse all wetsuits</a>.</p>';
      if (window.console) console.error('wetsuit-finder', e);
    });
    return f;
  }

  function auto() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wetsuit-finder]'), function (el) {
      if (el.dataset.mounted) return; el.dataset.mounted = '1';
      mount(el, {
        endpoint: el.dataset.endpoint || undefined,
        assetBase: el.dataset.assetBase || undefined,
        sizeGuideUrl: el.dataset.sizeGuide || undefined,
        contactUrl: el.dataset.contact || undefined,
        showVintage: el.dataset.showVintage !== 'false',
        showKit: el.dataset.showKit !== 'false'
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto); else auto();
  document.addEventListener('shopify:section:load', auto);

  window.WetsuitFinder = { mount: mount, classify: classify, recommend: recommend, sizeFor: sizeFor, BANDS: BANDS, IMAGES: IMAGES };
})();
